<template>
  <div id="Customize">
    <Header :title="$t('Header.ClassRoom')" logoutPath="/login" />
    <Menu />

    <div class="pnlBEContent scrollBar">
      <template v-if="editing == false">
        <TitleBar
          :iconSrc="require('@/assets/img/models/icon_Custom_Hover.png')"
          :title="$t('Customize.PageName')"
        >
          <button class="btnWidthIconTitle iconAdd" @click="ShowAddClassList">
            {{ $t("Customize.BtnAddCustomize") }}
          </button>
          <button class="btnInformation" @click="ShowFolderSOP"></button>
        </TitleBar>

        <div class="pnlBESearchScroll">
          <div class="pnlModelSetItem" @click="ShowAddClassList">
            <div class="btnFolderAdd"></div>
          </div>

          <FadeTransition group>
            <FolderModel
              v-for="classInfo in classList"
              :key="classInfo.id"
              :titleName="classInfo.text"
              :txtEdit="$t('Customize.btnFolderEdit')"
              :txtDel="$t('Customize.btnFolderDel')"
              @into-folder="OpenEditing(classInfo)"
              @rename="ShowEditClassList(classInfo)"
              @show-del="ShowDeleteClass(classInfo)"
            ></FolderModel>
          </FadeTransition>
        </div>
      </template>
      <template v-if="editing">
        <TitleBar
          :iconSrc="require('@/assets/img/sg/icon_folder_Hover.png')"
          :title="classList[nowEditingIndex].text"
        ></TitleBar>
        <div class="pnlCustomizeTab">
          <div :class="tabStyleModel" @click="SwitchModels">
            {{ $t("Customize.TabModel") }}
          </div>
          <div :class="tabStyleBulletin" @click="SwitchBulletins">
            {{ $t("Customize.TabBulletin") }}
          </div>
          <div style="clear: both"></div>
          <div class="line"></div>
        </div>

        <template v-if="showModels">
          <template v-if="!sorting">
            <button class="btnWidthIcon iconBack" @click="CloseEditing">
              {{ $t("Customize.BtnBack") }}
            </button>
            <button
              v-if="sortingModels != null && sortingModels.length != 0"
              class="btnWidthIcon iconSort"
              @click="OpenSorting"
            >
              {{ $t("Customize.BtnSorting") }}
            </button>
          </template>
          <template v-else>
            <button class="btnWidthIcon iconSortDone" @click="CloseSorting">
              {{ $t("Customize.BtnSortDone") }}
            </button>
            <label class="lblSortHint">{{ $t("Customize.HintSort") }}</label>
          </template>
          <button
            class="btnInformation"
            style="margin-top: 2px"
            @click="ShowModelSOP"
          ></button>
          <div
            :class="pnlBEModelScroll"
            style="height: calc(100vh - 86px - 6px - 83px - 67px - 65px)"
          >
            <label
              class="lblPlzSearch"
              v-if="sortingModels == null || sortingModels.length == 0"
              >{{ $t("Customize.HintNoModel") }}
            </label>
            <Draggable
              v-model="sortingModels"
              :disabled="!sorting"
              :animation="200"
            >
              <CustomModel
                v-for="(model, index) in sortingModels"
                :key="model.id"
                :name="model.name"
                :imgUrl="$t('PhotoPath', { key: model.keyword })"
                :index="index"
                @delete-model="DeleteModel"
              ></CustomModel>
            </Draggable>
          </div>
        </template>
        <template v-else>
          <template v-if="sortingBulletinSwitch == false">
            <button class="btnWidthIcon iconBack" @click="CloseEditing">
              {{ $t("Customize.BtnBack") }}
            </button>
            <template
              v-if="sortingBulletins != null && sortingBulletins.length != 0"
            >
              <button
                class="btnWidthIcon iconAdd btnLock"
                @click="UploadFileHint"
              >
                {{ $t("Customize.BtnBulletinUpload") }}
              </button>
              <button
                class="btnWidthIcon iconSort"
                @click="OpenSortingBulletins"
              >
                {{ $t("Customize.BtnSorting") }}
              </button>
              <button
                class="btnWidthIcon iconDelete"
                @click="ShowDelBulletinDialog(0, true)"
              >
                {{ $t("Customize.BtnBulletinDeleteAll") }}
              </button>
            </template>
            <template
              v-if="sortingBulletins == null || sortingBulletins.length == 0"
            >
              <div class="pnlUploadArea">
                <label class="btnWidthIcon iconAdd">{{
                  $t("Customize.BtnBulletinUpload")
                }}</label>
                <input
                  type="file"
                  id="file-to-upload"
                  accept="application/pdf"
                  class="fuClass"
                  @change="FileChange"
                />
              </div>
            </template>
          </template>
          <template v-else>
            <button
              class="btnWidthIcon iconSortDone"
              @click="CloseSortingBulletins"
            >
              {{ $t("Customize.BtnSortDone") }}
            </button>
            <label class="lblSortHint">{{ $t("Customize.HintSort") }}</label>
          </template>
          <button
            class="btnInformation"
            style="margin-top: 2px"
            @click="ShowPDFSOP"
          ></button>
          <div
            :class="pnlBEModelScroll"
            style="height: calc(100vh - 86px - 6px - 83px - 67px - 65px)"
          >
            <label
              class="lblPlzSearch"
              v-if="sortingBulletins == null || sortingBulletins.length == 0"
              >{{ $t("Customize.HintNoBulletin") }}</label
            >
            <Draggable
              v-model="sortingBulletins"
              :disabled="!sortingBulletinSwitch"
              :animation="200"
            >
              <CustomBulletin
                v-for="(bulletin, index) in sortingBulletins"
                :key="bulletin.id"
                :name="bulletin.name"
                :imgUrl="bulletin.photopath"
                :index="index"
                @edit-bulletin="ShowEditBulletinsDialog(index)"
                @del-bulletin="ShowDelBulletinDialog(index, false)"
              />
            </Draggable>
          </div>
        </template>
      </template>
    </div>

    <transition name="fade">
      <div
        class="pnlDialogFull"
        v-show="showAddInput"
        style="animation-duration: 0.2s"
      >
        <div class="pnlDialogGray">
          <div class="pnlDialogSet">
            <div class="pnlAddTitle">
              <label>{{ $t("Customize.TitleAddCustomizeSet") }}</label>
              <img
                class="btnDialogXX"
                src="@/assets/img/icon_btn/btn_close.png"
                @click="CloseClassList"
              />
            </div>
            <div class="pnlAddTxt">
              <input
                class="chkboxClassType"
                type="checkbox"
                v-model="selectOwnClass"
                @click="UnselectCustomizeClass()"
              />
              <label class="lblChkBoxTitle" @click="UnselectCustomizeClass()">{{
                $t("Customize.TitleAddOwnSet")
              }}</label>
              <br />

              <select
                v-model="ownClassSelect"
                class="ddlOwnClass"
                v-if="selectOwnClass"
              >
                <option
                  v-for="option in ownClassOptions"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <input
                class="chkboxClassType"
                type="checkbox"
                v-model="selectCustomizeClass"
                @click="UnselectOwnClass()"
              />
              <label class="lblChkBoxTitle" @click="UnselectOwnClass()">{{
                $t("Customize.TitleAddCustomizeSet")
              }}</label>
              <input
                class="txtbSetName"
                :placeholder="$t('Customize.PlaceholderSetName')"
                v-on:keyup.enter="AddClassList"
                v-on:keyup.esc="CloseClassList"
                v-model.trim="inputText"
                ref="inputDialog"
                v-if="selectCustomizeClass"
              />
              <div class="pnlBtnArea">
                <button class="btnAddConfirm" @click="AddClassList">
                  {{ $t("Customize.BtnAddCustomize") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <DialogOneKeyin
      :show="dialogClassRename.isShow"
      :title="dialogClassRename.title"
      :inputText="dialogClassRename.name"
      :inputPlaceholder="dialogClassRename.inputPlaceholder"
      :btnText="dialogClassRename.btnText"
      @close-dialog="CloseClassList"
      @btn-click="EditClassList"
      ref="classRename"
    />

    <DialogOneKeyin
      :show="dialogBulletinRename.isShow"
      :title="dialogBulletinRename.title"
      :inputText="dialogBulletinRename.name"
      :inputPlaceholder="dialogBulletinRename.inputPlaceholder"
      :btnText="dialogBulletinRename.btnText"
      @close-dialog="CloseClassList"
      @btn-click="EditBulletins"
      ref="BulletinRename"
    />

    <DialogTwoBtn
      :show="dialogGoAdd.isShow"
      :title="dialogGoAdd.title"
      :content="dialogGoAdd.content"
      :btnRightText="dialogGoAdd.btnRightText"
      :btnLeftText="dialogGoAdd.btnLeftText"
      @close-dialog="CloseGoAddDialog"
      @btn-right-click="GoFavorite"
      @btn-left-click="GoModels"
    />

    <DialogTwoBtn
      :show="dialogDelClass.isShow"
      :title="dialogDelClass.title"
      :content="dialogDelClass.content"
      :btnRightText="dialogDelClass.btnRightText"
      :btnLeftText="dialogDelClass.btnLeftText"
      @close-dialog="CloseClassList"
      @btn-right-click="DeleteClass"
      @btn-left-click="CloseClassList"
    />

    <DialogTwoBtn
      :show="dialogDelBulletin.isShow"
      :title="dialogDelBulletin.title"
      :content="dialogDelBulletin.content"
      :btnRightText="dialogDelBulletin.btnRightText"
      :btnLeftText="dialogDelBulletin.btnLeftText"
      @close-dialog="CloseClassList"
      @btn-right-click="
        delAllBulletin == true ? DeleteAllBulletins() : DeleteBulletins()
      "
      @btn-left-click="CloseClassList"
    />

    <DialogHint
      :show="dialogHint.isShow"
      :msgs="dialogHint.msg"
      :btnTxt="dialogHint.btnTxt"
      :imgSrc="dialogHint.imgSrc"
      @close-dialog="CloseHintDialog"
      @btn-click="CloseHintDialog"
    />

    <Loading
      :active.sync="loadingInfo.isLoading"
      :can-cancel="false"
      :is-full-page="true"
      :color="loadingInfo.color"
      :opacity="loadingInfo.opacity"
      :background-color="loadingInfo.bgColor"
    ></Loading>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import TitleBar from "@/components/TitleBar.vue";
import FolderModel from "@/components/SurrealClassRoom/FolderModel.vue";
import CustomModel from "@/components/SurrealClassRoom/CustomModel.vue";
import CustomBulletin from "@/components/SurrealClassRoom/CustomBulletin.vue";
import DialogHint from "@/components/Dialog/DialogHint.vue";
import DialogTwoBtn from "@/components/Dialog/DialogTwoBtn.vue";
import DialogOneKeyin from "@/components/Dialog/DialogOneKeyin.vue";
import Draggable from "vuedraggable";
import { FadeTransition } from "vue2-transitions";
import Loading from "vue-loading-overlay";

import "vue-loading-overlay/dist/vue-loading.css";
import $ from "jquery";
//import PDFJS from "pdfjs-dist";
const pdfjs = require("pdfjs-dist/legacy/build/pdf.js");
import {
  apiGetAddClass,
  apiAddClassList,
  apiDelClassList,
  apiUpdateClassListName,
  apiGetModelsByListID,
  apiUpdateClass,
  apiUpdateClassListSorting,
  apiGetOwnModelSet,
  apiCopyOwnModelSet,
  apiAddBoard,
  apiGetBoard,
  apiEditBoard,
  apiEditBoardSort,
  apiDelBoard,
  apiDelAllBoard,
} from "@/request.js";
export default {
  mounted() {
    apiGetAddClass().then((res) => {
      if (res.data.modelset != null) {
        this.classList = res.data.modelset;
      }
    });
    apiGetOwnModelSet().then((res) => {
      this.ownClassOptions = res.data.ownclassoptions;
    });
  },
  data() {
    return {
      loadingInfo: {
        isLoading: false,
        color: "#fff",
        opacity: 0.9,
        bgColor: "#131217",
      },
      dialogHint: {
        isShow: false,
        msg: [],
        btnTxt: "",
        imgSrc: "",
      },
      dialogGoAdd: {
        isShow: false,
        title: this.$t("Customize.HintNoModel"),
        content: this.$t("Customize.HintNoModelContent"),
        btnRightText: this.$t("Favorite.PageName"),
        btnLeftText: this.$t("Models.PageName"),
      },
      dialogDelClass: {
        isShow: false,
        title: "",
        content: this.$t("Customize.HintDelCustomizeContent"),
        btnRightText: this.$t("Customize.BtnDelete"),
        btnLeftText: this.$t("Customize.BtnCancel"),
      },
      dialogDelBulletin: {
        isShow: false,
        title: "",
        content: this.$t("Customize.HintDelBulletinContent"),
        btnRightText: this.$t("Customize.BtnDelete"),
        btnLeftText: this.$t("Customize.BtnCancel"),
      },
      dialogClassRename: {
        isShow: false,
        name: "",
        title: this.$t("Customize.TitleRename"),
        inputPlaceholder: this.$t("Customize.PlaceholderSetName"),
        btnText: this.$t("Customize.BtnSave"),
      },
      dialogBulletinRename: {
        isShow: false,
        name: "",
        title: this.$t("Customize.TitleRename"),
        inputPlaceholder: this.$t("Customize.PlaceholderBulletinName"),
        btnText: this.$t("Customize.BtnSave"),
      },
      inputText: "",
      selectOwnClass: false,
      selectCustomizeClass: false,
      editing: false,
      sorting: false,
      nowEditingIndex: -1,
      showAddInput: false,
      showEditingInput: false,
      sortingModels: [],
      showModels: true,
      classList: [],
      sortingBulletinSwitch: false,
      sortingBulletins: [],
      ownClassSelect: "1",
      ownClassOptions: [],
      nowEditingIndexChild: -1,
      delAllBulletin: false,
      pdf: {
        pdfDoc: null,
        totalPages: 0,
        currentPages: 1,
        title: "",
        scale: 1.0,
        pdfData: { filename: "", images: [] },
        pdfMaxPages: 45,
      },
      modelsetMaxNum: 15,
    };
  },
  computed: {
    pnlBEModelScroll: function () {
      if (this.sorting || this.sortingBulletinSwitch) {
        return "pnlBESort";
      }
      return "pnlBESearchScroll";
    },
    tabStyleModel: function () {
      if (this.showModels) {
        return "tabSelect";
      }
      return "tabUnSelect";
    },
    tabStyleBulletin: function () {
      if (this.showModels) {
        return "tabUnSelect";
      }
      return "tabSelect";
    },
  },
  methods: {
    getClassEditIdx(classInfo) {
      return this.classList.findIndex((obj) => obj.id == classInfo.id);
    },
    AddClassList() {
      if (this.selectOwnClass) {
        var strSelectClassName = this.ownClassOptions.find(
          (obj) => obj.id == this.ownClassSelect
        ).name;

        apiCopyOwnModelSet({
          id: Number(this.ownClassSelect),
          name: strSelectClassName,
        }).then((res) => {
          if (res.data.status == "ok") {
            this.$toasted.show(
              this.$t("Customize.ErrMsg.HintCopyDone", {
                msg: strSelectClassName,
              }),
              {
                icon: "check",
                position: "bottom-center",
                duration: 2500,
              }
            );
            this.classList.push(res.data.model);
            this.showAddInput = false;
          } else {
            this.$toasted.show(this.$t("Account.ErrMsg.ErrServerBusy"), {
              icon: "warning",
              position: "bottom-center",
              duration: 2500,
            });
          }
        });
      } else if (this.selectCustomizeClass) {
        if (this.inputText == "") {
          this.$toasted.show(this.$t("Customize.ErrMsg.KeyinCustomizeName"), {
            icon: "warning",
            position: "bottom-center",
            duration: 2500,
          });
          return;
        }
        apiAddClassList({
          name: this.inputText,
          model_ids: [],
        }).then((res) => {
          this.$toasted.show(
            this.$t("Customize.ErrMsg.HintAddCustomize", {
              msg: this.inputText,
            }),
            {
              icon: "check",
              position: "bottom-center",
              duration: 2500,
            }
          );

          this.classList.push(res.data.model);
          this.showAddInput = false;
          this.inputText = "";
        });
      }
    },
    EditClassList(info) {
      this.dialogClassRename.name = info.name;
      if (this.dialogClassRename.name == "") {
        return;
      }
      apiUpdateClassListName(this.classList[this.nowEditingIndex].id, {
        name: this.dialogClassRename.name,
      }).then(() => {
        this.$toasted.show(
          this.$t("Customize.ErrMsg.HintRenameCustomize", {
            msg: this.dialogClassRename.name,
          }),
          {
            icon: "check",
            position: "bottom-center",
            duration: 2500,
          }
        );

        this.classList[this.nowEditingIndex].text = this.dialogClassRename.name;
        this.dialogClassRename.isShow = false;
        this.dialogClassRename.name = "";
      });
    },
    ShowAddClassList() {
      this.showAddInput = true;
    },
    CloseClassList() {
      this.showAddInput = false;
      this.dialogClassRename.isShow = false;
      this.dialogDelClass.isShow = false;
      this.dialogBulletinRename.isShow = false;
      this.dialogDelBulletin.isShow = false;
      this.inputText = "";
    },
    OpenEditing(classInfo) {
      this.loadingInfo.isLoading = true;
      apiGetModelsByListID(classInfo.id).then((res) => {
        classInfo.models = res.data.modelset.model_ids;
        this.sortingModels = res.data.modelset.model_ids;
        this.editing = true;
        this.nowEditingIndex = this.getClassEditIdx(classInfo);

        if (this.sortingModels == null || this.sortingModels.length == 0) {
          this.dialogGoAdd.isShow = true;
        }
        this.loadingInfo.isLoading = false;
      });
      apiGetBoard(classInfo.id).then((res) => {
        if (res.data.Bulletins != null) {
          classInfo.Bulletins = res.data.Bulletins;
          this.sortingBulletins = res.data.Bulletins;
        } else {
          classInfo.Bulletins = [];
          this.sortingBulletins = [];
        }
      });
    },
    CloseEditing() {
      this.editing = false;
      this.nowEditingIndex = -1;
    },
    OpenSorting() {
      this.sorting = true;
    },
    CloseSorting() {
      var model_ids = Object.values(this.sortingModels).map((item) => item.id);
      var data = { model_ids: model_ids };
      apiUpdateClassListSorting(
        this.classList[this.nowEditingIndex].id,
        data
      ).then(() => {
        this.sorting = false;
      });
    },
    ShowEditClassList(classInfo) {
      this.nowEditingIndex = this.getClassEditIdx(classInfo);
      this.dialogClassRename.name = classInfo.text;
      this.dialogClassRename.isShow = true;
    },
    ShowDeleteClass(classInfo) {
      this.nowEditingIndex = this.getClassEditIdx(classInfo);
      this.dialogDelClass.isShow = true;
      this.dialogDelClass.title = this.$t("Customize.HintDelCustomizeTitle", {
        msg: this.classList[this.nowEditingIndex].text,
      });
    },
    DeleteClass() {
      apiDelClassList(this.classList[this.nowEditingIndex].id).then(() => {
        this.editing = false;
        this.dialogDelClass.isShow = false;
        this.$toasted.show(
          this.$t("Customize.ErrMsg.HintDelCustomize", {
            msg: this.classList[this.nowEditingIndex].text,
          }),
          {
            icon: "delete",
            position: "bottom-center",
            duration: 2500,
          }
        );
        this.classList.splice(this.nowEditingIndex, 1);
      });
    },
    DeleteModel(info) {
      let index = info.index;
      apiUpdateClass(this.classList[this.nowEditingIndex].id, {
        remove_ids: [this.classList[this.nowEditingIndex].models[index].id],
      }).then(() => {
        this.classList[this.nowEditingIndex].models.splice(index, 1);
      });
    },
    OpenSortingBulletins() {
      this.sortingBulletinSwitch = true;
    },
    CloseSortingBulletins() {
      var boardids = Object.values(this.sortingBulletins).map(
        (item) => item.id
      );
      apiEditBoardSort(this.classList[this.nowEditingIndex].id, {
        board_ids: boardids,
      }).then(() => {
        this.classList[this.nowEditingIndex].Bulletins = this.sortingBulletins;
        this.sortingBulletinSwitch = false;
      });
    },
    ShowEditBulletinsDialog(index) {
      this.nowEditingIndexChild = index;
      this.dialogBulletinRename.name = this.classList[
        this.nowEditingIndex
      ].Bulletins[index].name;
      this.dialogBulletinRename.isShow = true;
    },
    EditBulletins(info) {
      this.dialogBulletinRename.name = info.name;
      if (this.dialogBulletinRename.name == "") {
        return;
      }
      apiEditBoard(
        this.classList[this.nowEditingIndex].Bulletins[
          this.nowEditingIndexChild
        ].id,
        { name: this.dialogBulletinRename.name }
      ).then((res) => {
        if (res.data.status == "ok") {
          this.$toasted.show(
            this.$t("Customize.ErrMsg.HintEditBulletin", {
              msg: this.dialogBulletinRename.name,
            }),
            {
              icon: "check",
              position: "bottom-center",
              duration: 2500,
            }
          );
          this.classList[this.nowEditingIndex].Bulletins[
            this.nowEditingIndexChild
          ].name = this.dialogBulletinRename.name;
          this.dialogBulletinRename.isShow = false;
          this.dialogBulletinRename.name = "";
        } else {
          this.$toasted.show(this.$t("Account.ErrMsg.ErrServerBusy"), {
            icon: "warning",
            position: "bottom-center",
            duration: 2500,
          });
        }
      });
    },
    ShowDelBulletinDialog(index, delAll) {
      this.delAllBulletin = delAll;
      if (delAll == false) this.nowEditingIndexChild = index;
      this.dialogDelBulletin.isShow = true;
      this.dialogDelBulletin.title =
        this.delAllBulletin == true
          ? "刪除所有投影片"
          : this.$t("Customize.HintDelCustomizeTitle", {
              msg: this.classList[this.nowEditingIndex].Bulletins[
                this.nowEditingIndexChild
              ].name,
            });
    },
    DeleteBulletins() {
      var index = this.nowEditingIndexChild;
      var id = this.classList[this.nowEditingIndex].Bulletins[index].id;
      var setid = this.classList[this.nowEditingIndex].id;
      var tmpBulletins = JSON.parse(
        JSON.stringify(this.classList[this.nowEditingIndex].Bulletins)
      ); //by value
      tmpBulletins.splice(index, 1);

      var boardids = Object.values(tmpBulletins).map((item) => item.id);
      apiDelBoard(id, setid, "[" + boardids + "]").then(() => {
        this.classList[this.nowEditingIndex].Bulletins.splice(index, 1);
        this.dialogDelBulletin.isShow = false;
      });
    },
    DeleteAllBulletins() {
      apiDelAllBoard(this.classList[this.nowEditingIndex].id).then(() => {
        this.classList[this.nowEditingIndex].Bulletins.splice(0);
        this.dialogDelBulletin.isShow = false;
      });
    },
    CloseGoAddDialog() {
      this.dialogGoAdd.isShow = false;
    },
    GoModels() {
      this.$router.push({ path: "/SurrealClassRoom/models" });
      this.nowTab = "models";
    },
    GoFavorite() {
      this.$router.push({ path: "/SurrealClassRoom/favorite" });
      this.nowTab = "favorite";
    },
    SwitchModels() {
      if (this.showModels == false) {
        this.showModels = true;
        this.sorting = false;
        this.sortingBulletinSwitch = false;
      }
    },
    SwitchBulletins() {
      if (this.showModels == true) {
        this.showModels = false;
        this.sorting = false;
        this.sortingBulletinSwitch = false;
      }
    },
    UnselectCustomizeClass() {
      this.selectOwnClass = true;
      this.selectCustomizeClass = false;
    },
    UnselectOwnClass() {
      this.selectOwnClass = false;
      this.selectCustomizeClass = true;
    },
    UploadFileHint() {
      this.$toasted.show(this.$t("Customize.ErrMsg.HintUploadFileDeleteAll"), {
        icon: "warning",
        position: "bottom-center",
        duration: 4000,
      });
    },
    FileChange() {
      if (
        ["application/pdf"].indexOf(
          $("#file-to-upload").get(0).files[0].type
        ) == -1
      ) {
        alert("Error : Not a PDF");
        return;
      }
      this.GetPDF(URL.createObjectURL($("#file-to-upload").get(0).files[0]));
    },
    GetPDF(pdf_url) {
      this.loadingInfo.isLoading = true;
      pdfjs.getDocument({ url: pdf_url })
        .then((pdf_doc) => {
          this.pdf.pdfDoc = pdf_doc;
          this.pdf.totalPages = this.pdf.pdfDoc.numPages;
          this.pdf.title = $("#file-to-upload").get(0).files[0].name;
          this.pdf.pdfData.filename = this.pdf.title.substring(
            0,
            this.pdf.title.length - 4
          ); //cut .pdf

          if (this.pdf.totalPages > this.pdf.pdfMaxPages) {
            //this.$t("Customize.ErrMsg.HintPdfLimit")
            this.loadingInfo.isLoading = false;
            this.$toasted.show(
              this.$t("Customize.ErrMsg.HintPdfLimit", {
                msg: this.pdf.pdfMaxPages,
              }),
              {
                icon: "warning",
                position: "bottom-center",
                duration: 2500,
              }
            );
          } else {
            this.GetPDFPage(
              this.pdf.pdfData.images,
              this.GetPDFPage,
              this.UpLoadFile
            );
          }
        })
        .catch(function (error) {
          alert(error.message);
        });
    },
    GetPDFPage(arrImgB64, callGetPDFPage, CallUpLoadFile) {
      this.pdf.pdfDoc.getPage(this.pdf.currentPages).then((page) => {
        var viewport = page.getViewport(this.pdf.scale);
        var canvas = document.createElement("canvas"),
          ctx = canvas.getContext("2d");
        var renderContext = { canvasContext: ctx, viewport: viewport };

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var totalPage = this.pdf.totalPages;
        var currentPage = this.pdf.currentPages;

        page.render(renderContext).then(function () {
          arrImgB64.push(canvas.toDataURL());
          if (currentPage < totalPage) {
            callGetPDFPage(arrImgB64, callGetPDFPage, CallUpLoadFile);
          } else {
            CallUpLoadFile();
          }
        });

        this.pdf.currentPages++;
      });
    },
    UpLoadFile() {
      apiAddBoard(
        this.classList[this.nowEditingIndex].id,
        this.pdf.pdfData
      ).then((res) => {
        this.loadingInfo.isLoading = false;
        if (res.data.status == "ok") {
          this.sortingBulletins = res.data.Bulletins;
          this.classList[this.nowEditingIndex].Bulletins = res.data.Bulletins;
        } else {
          this.$toasted.show(this.$t("Account.ErrMsg.ErrServerBusy"), {
            icon: "warning",
            position: "bottom-center",
            duration: 2500,
          });
        }
      });
    },
    CloseHintDialog() {
      this.dialogHint.isShow = false;
    },
    ShowFolderSOP() {
      this.dialogHint.isShow = true;
      //this.dialogHint.msg = this.$t("Customize.HintFolderSOP");
      var tmpMsg = this.$t("Customize.HintFolderSOP");
      this.dialogHint.msg = tmpMsg.split("<br>");
      this.dialogHint.btnTxt = this.$t("Customize.BtnConfirm");
      this.dialogHint.imgSrc = require("@/assets/img/icon_btn/icon_help.png");
    },
    ShowModelSOP() {
      this.dialogHint.isShow = true;
      var tmpMsg = this.$t("Customize.HintModelSOP", {
        msg: this.modelsetMaxNum,
      });
      this.dialogHint.msg = tmpMsg.split("<br>");
      this.dialogHint.btnTxt = this.$t("Customize.BtnConfirm");
      this.dialogHint.imgSrc = require("@/assets/img/icon_btn/icon_help.png");
    },
    ShowPDFSOP() {
      this.dialogHint.isShow = true;
      var tmpMsg = this.$t("Customize.HintPDFSOP", {
        msg: this.pdf.pdfMaxPages,
      });
      this.dialogHint.msg = tmpMsg.split("<br>");
      this.dialogHint.btnTxt = this.$t("Customize.BtnConfirm");
      this.dialogHint.imgSrc = require("@/assets/img/icon_btn/icon_help.png");
    },
  },
  components: {
    Header,
    Menu,
    TitleBar,
    FolderModel,
    CustomModel,
    CustomBulletin,
    Draggable,
    FadeTransition,
    Loading,
    DialogHint,
    DialogTwoBtn,
    DialogOneKeyin,
  },
};
</script>